import api from './api'

const optionService = {
  // PUBLIC - form lấy option đang active (gom theo category)
  async getPublic() {
    const response = await api.get('/options')
    return response.data
  },

  // ADMIN - lấy tất cả (kể cả option đã ẩn)
  async list() {
    const response = await api.get('/options', { params: { include_inactive: 1 } })
    return response.data
  },

  async create(data) {
    const response = await api.post('/options', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/options/${id}`, data)
    return response.data
  },

  async remove(id) {
    const response = await api.delete(`/options/${id}`)
    return response.data
  },
}

// Nhãn + thứ tự hiển thị các danh mục option
export const OPTION_CATEGORIES = [
  { key: 'position', label: 'Vị trí ứng tuyển' },
  { key: 'work_area', label: 'Khu vực làm việc' },
  { key: 'experience', label: 'Kinh nghiệm' },
  { key: 'source', label: 'Nguồn' },
]

export default optionService
